import { FC } from "react";
import { IconProps } from "./types";

export const Calendar: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 13C8.55228 13 9 13.4477 9 14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13Z"
      fill={fill}
    />
    <path
      d="M12 13C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13Z"
      fill={fill}
    />
    <path
      d="M16 13C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14C15 13.4477 15.4477 13 16 13Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 5H16.5V3H17.5V5H18.4004C19.2837 5.00021 19.9998 5.71626 20 6.59961V19.4004L19.9922 19.5635C19.9103 20.3702 19.2287 20.9998 18.4004 21H5.59961C4.7713 20.9998 4.08966 20.3702 4.00781 19.5635L4 19.4004V6.59961C4.00021 5.71626 4.71626 5.00021 5.59961 5H6.5V3H7.5V5ZM5 19.4004C5.00021 19.7315 5.26855 19.9998 5.59961 20H18.4004C18.7315 19.9998 18.9998 19.7315 19 19.4004V10.5H5V19.4004ZM5.59961 6C5.30966 6.00018 5.06745 6.20596 5.01172 6.47949L5 6.59961V9.5H19V6.59961C18.9998 6.30966 18.794 6.06745 18.5205 6.01172L18.4004 6H5.59961Z"
      fill={fill}
    />
  </svg>
);
